import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { blogs } from "./Blog";
import "../Css/Blog.css";

const BlogDetail = () => {
  const { slug } = useParams();
  const blog = blogs.find((b) => b.slug === slug);
  const [openFaqs, setOpenFaqs] = useState({});

  if (!blog) return <p>Blog not found</p>;

  // Parse FAQ questions and answers from paragraphs
  const parseContent = (content) => {
    if (!content || !content.paragraphs || !Array.isArray(content.paragraphs)) {
      return { regularContent: [], faqs: [] };
    }
    
    const paragraphs = content.paragraphs;
    const faqs = [];
    const regularContent = [];
    
    let i = 0;
    while (i < paragraphs.length) {
      const para = paragraphs[i];
      
      if (!para) {
        i++;
        continue;
      }
      
      const faqMatch = para.match(/^Q(\d+)\.\s+(.+)$/);
      if (faqMatch) {
        const qNumber = faqMatch[1];
        const question = faqMatch[2];
        const answer = paragraphs[i + 1]?.replace(/^Ans\.\s+/, "") || "";
        faqs.push({ number: qNumber, question, answer });
        i += 2;
      } else {
        const isHeading = para === "---" || 
                          (para.length < 60 && 
                           (para.includes("Books for") || 
                            para.includes("Importance of") ||
                            para.includes("How Many") ||
                            para.includes("Best Strategy") ||
                            para.includes("Common Mistakes") ||
                            para.includes("Frequently Asked") ||
                            para.includes("Conclusion") ||
                            para.includes("Why the Right") ||
                            para.includes("Physics Books") ||
                            para.includes("Chemistry Books") ||
                            para.includes("Mathematics Books") ||
                            para.includes("English Proficiency") ||
                            para.includes("Logical Reasoning")));
        
        if (isHeading && para !== "---") {
          regularContent.push({ type: "heading", text: para });
        } else if (para === "---") {
          regularContent.push({ type: "divider", text: para });
        } else {
          regularContent.push({ type: "paragraph", text: para });
        }
        i++;
      }
    }
    
    return { regularContent, faqs };
  };

  const { regularContent, faqs } = parseContent(blog.content);
  const toggleFaq = (index) => {
    setOpenFaqs(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  // ============================================
  // DYNAMIC META TAGS FOR EACH BLOG
  // ============================================
  
  // Get first 150-160 characters for meta description
  const getMetaDescription = () => {
    const firstPara = blog.content.paragraphs[0];
    if (firstPara && firstPara.length > 160) {
      return firstPara.substring(0, 157) + "...";
    }
    return firstPara || blog.title;
  };

  // Generate different meta titles based on blog slug
  const getMetaTitle = () => {
    const siteName = "IITian's Chinmay Academy";
    
    switch(blog.slug) {

      case "how-to-analyse-neet-mock-tests":
  return `How to Analyse NEET Mock Tests and Increase Your Score`;

      case "how-many-mock-tests-before-jee-main":
  return `How Many Mock Tests Should You Take Before JEE Main?`;

      case "jee-main-vs-jee-advanced-difference":
  return `JEE Main vs JEE Advanced: What Is the Difference?`;

      case "how-to-avoid-procrastination-and-focus-better-on-studies":
      return `Avoid Procrastination and Improve Study Focus | Student Productivity Tips`;

      case "best-time-to-study-morning-vs-night":
      return `Best Time to Study for Students | Morning vs Night Study`;

      case "how-to-overcome-exam-fear-and-anxiety-before-exams":
      return `How to Overcome Exam Fear and Anxiety Before Exams | Stress Management Tips`;
      
      case "top-10-study-habits-of-jee-and-neet-toppers":
      return `Top 10 Study Habits of JEE and NEET Toppers for Success | Study Tips`;

      case "how-to-stay-motivated-during-jee-neet-and-board-exam-preparation":
      return `Stay Motivated During JEE, NEET & Board Exam Preparation | Study Tips`;

      case "how-to-score-good-marks-in-exams-even-if-you-start-late":
      return `Score Good Marks in Exams Even If You Start Late`;
      case "best-coaching-for-class-9-10-science-in-vadodara":
        return `Best Coaching for Class 9 & 10 Science in Vadodara | IITians Chinmay Academy`;
      case "best-books-for-bitsat-preparation-2026":
        return `Best Books for BITSAT Preparation 2026 | Physics, Chemistry & Maths Books Guide`;
      case "how-personalized-mentorship-helps-students":
        return `How Personalized Mentorship Helps Students Excel in IIT JEE | ${siteName}`;
      case "why-concept-based-learning-matters":
        return `Why Concept-Based Learning Matters for IIT JEE & NEET Success | ${siteName}`;
      case "vision-iitians-chinmay-academy":
        return `Vision & Teaching Philosophy of IITians Chinmay Academy | ${siteName}`;
      
        case "how-to-concentrate-on-studies-for-long-hours":
    return `How to Concentrate on Studies for Long Hours | Study Focus Tips | IITians Chinmay Academy`;

    case "why-do-i-forget-what-i-study":
  return `Why Do I Forget What I Study? | 10 Memory Improvement Techniques | IITians Chinmay Academy`;

case "how-to-make-a-perfect-study-timetable":
  return `Perfect Study Timetable for Students | Study Plan for School & Competitive Exams | IITians Chinmay Academy`;







  default:
        return `${blog.title} | ${siteName}`;
    }
  };

  // Generate different meta descriptions based on blog slug
  const getMetaDescriptionForBlog = () => {
    switch(blog.slug) {

      case "how-to-analyse-neet-mock-tests":
  return "Learn how to analyse NEET mock tests, identify mistakes, improve weak areas, manage time better and increase your NEET exam score.";

      case "how-many-mock-tests-before-jee-main":
  return "Learn how many mock tests to take before JEE Main, when to start, how often to practise, and how to analyse tests for better results.";

      case "jee-main-vs-jee-advanced-difference":
  return "Discover the difference between JEE Main and JEE Advanced, including difficulty level, question style, eligibility, and how to prepare for both exams.";

      case "how-to-avoid-procrastination-and-focus-better-on-studies":
      return "Learn how to avoid procrastination and focus better on studies with proven productivity techniques, time management strategies, and concentration tips for students preparing for exams like JEE, NEET, and board exams.";

       case "best-time-to-study-morning-vs-night":
      return "Discover whether studying in the morning or at night is better for students. Learn the benefits, drawbacks, and how to find the best study time for maximum concentration and exam success.";

      case "how-to-overcome-exam-fear-and-anxiety-before-exams":
      return "Learn how to overcome exam fear and anxiety before exams with practical tips, relaxation techniques, positive thinking strategies, and proven methods to build confidence and reduce stress during exam preparation.";

      case "top-10-study-habits-of-jee-and-neet-toppers":
      return "Discover the top 10 study habits of JEE and NEET toppers. Learn proven study techniques, revision strategies, productivity tips, and exam preparation habits that lead to success.";

      case "how-to-stay-motivated-during-jee-neet-and-board-exam-preparation":
      return "Learn how to stay motivated during JEE, NEET, and board exam preparation with practical tips, study habits, mindset strategies, and productivity techniques for academic success.";

      case "how-to-score-good-marks-in-exams-even-if-you-start-late":
      return "Learn how to score good marks in exams even if you start late. Discover smart study techniques, revision strategies, time management tips, and exam preparation methods that work.";

      case "best-coaching-for-class-9-10-science-in-vadodara":
        return "Looking for the best coaching for Class 9 & 10 Science in Vadodara? IITians Chinmay Academy offers expert faculty, concept-based learning, regular tests, doubt-solving sessions, and strong preparation for board exams, JEE, and NEET foundations.";
      case "best-books-for-bitsat-preparation-2026":
        return "Searching for the best books for BITSAT 2026 preparation? Explore the top NCERT and reference books for Physics, Chemistry, Maths, English, and Logical Reasoning recommended by IITians Chinmay Academy.";
      case "how-personalized-mentorship-helps-students":
        return "Learn how personalized mentorship at IITian's Chinmay Academy helps students excel in IIT JEE preparation. Customized study plans, regular feedback, and focused guidance.";
      case "why-concept-based-learning-matters":
        return "Understand why concept-based learning is crucial for IIT JEE & NEET success. Build strong fundamentals, improve problem-solving skills, and reduce exam stress.";
      case "vision-iitians-chinmay-academy":
        return "Discover the vision and teaching philosophy of IITian's Chinmay Academy. Founded by IIT Kharagpur alumnus, providing fear-free conceptual learning for IIT JEE & NEET.";
      case "how-to-concentrate-on-studies-for-long-hours":
    return "Learn how to concentrate on studies for long hours without getting distracted. Discover proven study techniques, Pomodoro method, focus tips, and time management strategies to improve academic performance.";
case "why-do-i-forget-what-i-study":
  return "Discover why students forget what they study and learn 10 proven memory improvement techniques to boost concentration, retention, and exam performance. Active Recall, Spaced Repetition, and more.";
case "how-to-make-a-perfect-study-timetable":
  return "Learn how to make a perfect study timetable for school, board exams, JEE, NEET, and competitive exams. Discover practical time management and study planning tips for academic success.";




        default:
        return getMetaDescription();
    }
  };

  // Generate different keywords based on blog slug
  const getMetaKeywords = () => {
    const baseKeywords = blog.keywords || [];
    
    switch(blog.slug) {

      case "how-to-analyse-neet-mock-tests":
  return [...baseKeywords, "NEET mock test analysis", "increase NEET score", "NEET preparation tips", "NEET mock test strategy", "NEET coaching Vadodara"].join(', ');

      case "how-many-mock-tests-before-jee-main":
  return [...baseKeywords, "mock tests for JEE Main", "how many mock tests before JEE Main", "JEE Main mock test strategy", "mock test analysis", "JEE coaching Vadodara"].join(', ');
      
      case "jee-main-vs-jee-advanced-difference":
  return [...baseKeywords, "JEE Main vs JEE Advanced", "JEE Advanced difficulty level", "JEE Main preparation tips", "JEE Advanced preparation tips", "JEE coaching Vadodara"].join(', ');

      case "how-to-avoid-procrastination-and-focus-better-on-studies":
      return [...baseKeywords, "stop procrastinating", "study focus tips", "student productivity", "concentration tips", "time management", "exam preparation", "JEE preparation", "NEET preparation", "study habits"].join(', ');

      case "best-time-to-study-morning-vs-night":
      return [...baseKeywords, "study schedule", "morning study", "night study", "productive study time", "JEE preparation tips", "NEET preparation tips", "student productivity", "effective study routine"].join(', ');

      case "how-to-overcome-exam-fear-and-anxiety-before-exams":
      return [...baseKeywords, "exam stress relief", "anxiety management", "exam confidence tips", "student mental health", "stress management techniques", "exam preparation help", "fear of exams"].join(', ');

      case "top-10-study-habits-of-jee-and-neet-toppers":
      return [...baseKeywords, "study habits", "toppers study routine", "JEE preparation", "NEET preparation", "exam success tips", "productive study techniques", "revision strategies", "mock test tips"].join(', ');
      
      case "how-to-stay-motivated-during-jee-neet-and-board-exam-preparation":
      return [...baseKeywords, "study motivation", "exam motivation tips", "student motivation", "consistency in studies", "JEE motivation", "NEET motivation", "board exam motivation"].join(', ');

      
      case "how-to-score-good-marks-in-exams-even-if-you-start-late":
      return [...baseKeywords, "exam preparation tips", "score good marks", "study motivation", "last minute study tips", "exam strategy", "time management"].join(', ');
    case "best-coaching-for-class-9-10-science-in-vadodara":
      return [...baseKeywords, "Class 9 Science coaching", "Class 10 Science coaching", "Science tuition Vadodara", "board exam preparation", "JEE foundation", "NEET foundation"].join(', ');
      
      case "best-books-for-bitsat-preparation-2026":
        return [...baseKeywords, "BITSAT preparation tips", "BITSAT study material", "best books for BITSAT", "BITSAT 2026 strategy"].join(', ');
      case "how-personalized-mentorship-helps-students":
        return [...baseKeywords, "IIT JEE mentorship", "personalized coaching", "student success tips", "academic guidance"].join(', ');
      case "why-concept-based-learning-matters":
        return [...baseKeywords, "conceptual learning", "IIT JEE tips", "NEET preparation strategy", "smart learning"].join(', ');
      case "vision-iitians-chinmay-academy":
        return [...baseKeywords, "IIT JEE coaching Vadodara", "teaching philosophy", "IITian faculty", "best coaching institute"].join(', ');
      case "how-to-concentrate-on-studies-for-long-hours":
    return [...baseKeywords, "study concentration tips", "focus techniques", "avoid distractions", "Pomodoro technique", "exam preparation", "productivity"].join(', ');
case "why-do-i-forget-what-i-study":
  return [...baseKeywords, "memory improvement techniques", "why students forget", "study retention tips", "active recall method", "spaced repetition", "brain memory boost"].join(', ');

case "how-to-make-a-perfect-study-timetable":
  return [...baseKeywords, "study timetable for students", "time management tips", "exam study plan", "study schedule for JEE", "NEET preparation timetable", "productive study routine"].join(', ');


        default:
        return baseKeywords.join(', ');
    }
  };

  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';

  return (
    <>
      {/* Dynamic Meta Tags for EACH Blog - Different for every blog */}
      <Helmet>
        {/* Basic Meta Tags */}
        <title>{getMetaTitle()}</title>
        <meta name="description" content={getMetaDescriptionForBlog()} />
        <meta name="keywords" content={getMetaKeywords()} />
        
        {/* Open Graph / Facebook Meta Tags */}
        <meta property="og:title" content={getMetaTitle()} />
        <meta property="og:description" content={getMetaDescriptionForBlog()} />
        <meta property="og:image" content={blog.image} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="IITian's Chinmay Academy" />
        
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={getMetaTitle()} />
        <meta name="twitter:description" content={getMetaDescriptionForBlog()} />
        <meta name="twitter:image" content={blog.image} />
        
        {/* Additional SEO Meta Tags */}
        <meta name="author" content="IITian's Chinmay Academy" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={currentUrl} />
        
        {/* Article Specific Meta Tags */}
        <meta property="article:published_time" content={blog.date} />
        <meta property="article:section" content="Educational Blog" />
      </Helmet>

      <section className="blog-detail">
        <div className="blog-detail-grid">

          {/* MAIN CONTENT */}
          <article>
            <h1>{blog.title}</h1>
            <span className="detail-date">{blog.date}</span>

            <img
              src={blog.image}
              alt={blog.title}
              className="detail-image"
            />

            <div className="blog-content">
  {regularContent.map((item, idx) => {
    if (item.type === "heading") {
      return <h2 key={idx} dangerouslySetInnerHTML={{ __html: item.text }} />;
    } else if (item.type === "divider") {
      return <hr key={idx} className="content-divider" />;
    } else {
      // Check if paragraph contains list items
      if (item.text && (item.text.includes("•") || item.text.includes("✓") || item.text.includes("✗") || item.text.match(/^\d+\./))) {
        const lines = item.text.split(/\r?\n/);
        const listItems = lines.filter(line => 
          line.trim().startsWith("•") || 
          line.trim().startsWith("✓") || 
          line.trim().startsWith("✗") ||
          line.trim().match(/^\d+\./)
        );
        
        if (listItems.length > 0) {
          return (
            <ul key={idx} className="blog-list-styled">
              {listItems.map((line, liIdx) => (
                <li key={liIdx} dangerouslySetInnerHTML={{ __html: line.trim() }} />
              ))}
            </ul>
          );
        }
      }
      // Render paragraph with HTML support
      return <p key={idx} dangerouslySetInnerHTML={{ __html: item.text }} />;
    }
  })}


              {/* FAQ SECTION */}
              {faqs.length > 0 && (
                <div className="faq-section">
                  <h2>Frequently Asked Questions (FAQs)</h2>
                  <div className="faq-container">
                    {faqs.map((faq, index) => (
                      <div key={index} className="faq-item">
                        <div 
                          className="faq-question" 
                          onClick={() => toggleFaq(index)}
                        >
                          <span className="faq-icon">
                            {openFaqs[index] ? "−" : "+"}
                          </span>
                          <span className="faq-question-text">
                            Q{faq.number}. {faq.question}
                          </span>
                        </div>
                        <div className={`faq-answer ${openFaqs[index] ? "open" : ""}`}>
                          <p>{faq.answer}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </article>

          {/* SIDEBAR */}
          {/* SIDEBAR - Showing Latest 5 Blogs */}
<aside>
  <div className="sidebar-box">
    <h3>Recent Posts</h3>
    {blogs
      .slice(0, 5) // Only show latest 5 blogs
      .map((b) => (
        <Link key={b.slug} to={`/blog/${b.slug}`} className="recent-post">
          <img src={b.image} alt={b.title} />
          <div>
            <p>{b.title}</p>
            <span>{b.date}</span>
          </div>
        </Link>
      ))}
  </div>

  {/* <div className="sidebar-box">
    <h3>Popular Keywords</h3>
    <div className="keyword-tags">
      {blog.keywords && blog.keywords.map((k, i) => (
        <span key={i}>{k}</span>
      ))}
    </div>
  </div> */}
</aside>

        </div>
      </section>
    </>
  );
};

export default BlogDetail;